import React, { useState, useMemo } from 'react'
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import { Button } from '../utils/Button'
import Label from '../utils/Label'

import reserveApi from '../../utils/axios'
import Card from '../utils/Card'

import { STRIPE_KEYS } from '../../utils/constants'

// const stripePromise = loadStripe(STRIPE_KEYS.live)

const Stripe = ({ name, email, onSuccess, product, amount, validation }) => {
  const [isPaymentLoading, setPaymentLoading] = useState(false)
  const [stripeError, setStripeError] = useState()

  const stripe = useStripe()
  const elements = useElements()

  const payMoney = async e => {
    e.preventDefault()
    if (!stripe || !elements) {
      return
    }

    const isValid = validation()
    if (!isValid) {
      return
    }

    setPaymentLoading(true)
    const clientSecretResponse = await reserveApi({
      method: 'post',
      url: '/payments/stripe_intent',
      data: {
        product: product.key,
        amount: amount,
        name,
        email
      }
    })

    const clientSecret = clientSecretResponse.data.client_secret

    const paymentResult = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name,
          email
        }
      }
    })
    setPaymentLoading(false)
    if (paymentResult.error) {
      setStripeError(paymentResult.error.message)
    } else {
      if (paymentResult.paymentIntent.status === 'succeeded') {
        setStripeError(undefined)
        onSuccess('stripe', paymentResult)
      } else {
        setStripeError(paymentResult.paymentIntent.status)
      }
    }
  }

  return (
    <div className="mt-4">
      <Label className="mb-4">Credit Card</Label>
      {stripeError && (
        <Card color="lightOrange" small className="inline-block mt-1">
          <span className="text-lg font-bold">{stripeError}</span>
        </Card>
      )}
      <form onSubmit={payMoney}>
        <CardElement
          className="card"
          options={{
            classes: {
              base: 'p-2 rounded border border-gray-300'
            }
          }}
        />
        <Button type="submit" color="darkGreen" className="mt-6" disabled={isPaymentLoading}>
          {isPaymentLoading ? 'Loading...' : 'Submit'}
        </Button>
      </form>
    </div>
  )
}

const StripeWrapper = (props) => {
  const stripePromise = useMemo(() => {
    return loadStripe(STRIPE_KEYS.live)
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <Stripe {...props} />
    </Elements>
  )
}

export default StripeWrapper
